export default String.raw`

<div class="customer-submenu">
	<div class="customer-submenu__header submenu-header">
		<div class="navigation-header">
			<button class="pure-button load-erp-data-js load-first-lvl-js parent-container-reload-js" data-template="partials/customer-profile/invoices/invoices.html" data-url="{{page.Url}}?tab=invoices">
				<svg width="24" height="24">
					<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#long-arrow-left-{{settings.iconStyle}}"></use>
				</svg>
			</button>
			<div class="invoice">
				{{ translations.Document }} <div class="erp-number-js hidden-js"> </div>
			</div>
		</div>
	</div>
	<div class="erp-data-container-js" style="display: none">
		<div class="info-container-js expandable-mechanism-container-js">
			<div class="details-info">
				<div class="details">
					<div class="customer-info__content">
						<div class="title">{{ translations.BuyDate }}</div>
						<span>{ Date | date }</span>
					</div>
					<div class="customer-info__content">
						<div class="title">{{ translations.PaymentDueDate }}</div>
						<span rv-class-error="DaysAfterDueDate">{ DueDate | date }
							<span class="info-icon" rv-if="DaysAfterDueDate">
								<svg height="16" width="16">
									<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#info-circle-{{settings.iconStyle}}"></use>
								</svg> 
							</span>
							<span class="hover-text" rv-if="DaysAfterDueDate">{ DaysAfterDueDate } {{ translations.DaysAfterDeadline | Downcase }}</span>
						</span>
					</div>
				</div>
				<div class="details-info__summary">
					<div class="row-summ">
						<div class="title">{{ translations.Value }} {{ translations.Netto | Downcase }}</div>
						<span>{ SubtotalValue | price } { Currency }</span>
					</div>
					<div class="row-summ">
						<div class="title">{{ translations.Value }} {{ translations.Brutto | Downcase }}</div>
						<span>{ TotalValue | price } { Currency }</span>
					</div>
					<div class="summary" rv-if="ToPayExists">
						<div class="title">
							{{ translations.ToPay }} {{ translations.Brutto | Downcase }}
						</div>
						<span class="price">
							{ ToPay | price } { Currency }
						</span>
					</div>
					<div class="summary" rv-if="Pay">
						<div class="title">
							{{ translations.Paid }} {{ translations.Brutto | Downcase }}
						</div>
						<span rv-if="ToPayExists">
							{ Paid | price } { Currency }
						</span>
						<span rv-unless="ToPayExists">
							{ TotalValue | price } { Currency }
						</span>
					</div>
					<div class="summary" rv-if="Return">
						<div class="title">
							{{ translations.Returned }} {{ translations.Brutto | Downcase }}
						</div>
						<span rv-if="ToReturnExists">
							{ Returned | price } { Currency }
						</span>
						<span rv-unless="ToReturnExists">
							{ TotalValue | abs | price } { Currency }
						</span>
					</div>
					<div class="summary" rv-if="ToReturnExists">
						<div class="title">
							{{ translations.ToReturn }} {{ translations.Brutto | Downcase }}
						</div>
						<span>
							{ ToReturn | price } { Currency }
						</span>
					</div>
				</div>
			</div>
			<button class="pure-button expand-data-js change-arrow-title-js" title="{{ translations.ShowDetails }}">
				{{ translations.ShowDetails }} 
				<svg height="16" width="16" class="icon rotate-down dropdown-arrow">
					<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}"></use>
				</svg>
			</button>
			<div class="order-details expandable-js">
				<div class="order-details__row">
					<div class="order-details-item">
						<div class="title">{{ translations.PaymentMethod }}</div>
						<span>{ PaymentMethod }</span>
					</div>
					<div class="order-details-item">
						<div class="title">{{ translations.SaleDate }}</div>
						<span>{ ExpectedDate | date }</span>
					</div>
				</div>
				<div class="order-details__row">
					<div class="order-details-item" rv-if="EmailExists">
						<div class="title">{{ translations.BoughtBy }}</div>
						<span>{ Email }</span>
					</div>
					<div class="order-details-item" rv-if="StreetExists">
						<div class="title">{{ translations.ReciverData }}</div>
						<span>{ Name1 }</span>
						<span>{ Name2 }</span>
						<span>{ Street } { StreetNo }<span rv-if="UnitNoExists">/{ UnitNo }</span></span>
						<span>{ ZipCode } { City }</span>
					</div>
					<div class="order-details-item" rv-if="InvoiceStreetExists">
						<div class="title">{{ translations.BuyerData }}</div>
						<span>{ InvoiceName1 }</span>
						<span>{ InvoiceName2 }</span>
						<span>{ InvoiceTIN }</span>
						<span>{ InvoiceStreet } { InvoiceStreetNo }<span rv-if="InvoiceUnitNoExists">/{ InvoiceUnitNo }</span></span>
						<span>{ InvoiceZipCode } { InvoiceCity }</span>
					</div>
				</div>
				<div class="header-attributes-js" rv-if="AttributesExist"></div>
			</div>
			<div class="attachements-container" rv-if="InvoicePDFExists">
				<div class="title">{{ translations.Attachements }}</div>
				<div class="attachements">
					<div class="file-container">
						<button class="pure-button invoice-pdf-js">
							<svg height="24" width="24" class="svgIcon">
								<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#file-invoice-{{settings.iconStyle}}"></use>
							</svg> 
							<span>{{ translations.Invoice }}</span>
						</button>
					</div>
				</div>
			</div>
		</div>
		<div class="invoice-products-list-js container-js">
			{% include 'partials/customer-profile/products-list.html' -%}
		</div>
		<div class="related-erp hidden-js">
			<h5><strong>{{ translations.RelatedOrders }}</strong></h5>
			<div class="eshop__table-container">
				<table>
					<colgroup>
						<col style="width:90px">
						<col style="width:200px">
						<col style="width:200px">
						<col style="width:200px">
					</colgroup>
					<thead>
						<tr>
							<th class="id">{{ translations.Number | Capitalize }}</th>
							<th>{{ translations.DocumentDate }}</th>
							<th>{{ translations.Value }} {{ translations.Netto | Downcase }}</th>
							<th>{{ translations.Value }} {{ translations.Brutto | Downcase }}</th>
							<th>{{ translations.Currency }}</th>
						</tr>
					</thead>
					<tbody class="related-erp related-documents-js {% if settings.erpOrdersAvailability == 'yes' -%} erpOrdersAvailable-js {% endif -%} {% if settings.SORAvailability == 'yes' -%} SORAvailable-js {% endif -%}" rv-if="DocumentsExist" data-url-origin="{{ page.Url }}?&deeper-lvl=true&erp-data=true&" data-url-eshop-orders="{{ page.Url }}?{{ customer-profile.OrderQueryGET | H }}=">
					</tbody>
				</table>
			</div>
		</div>
	</div>
	<div class="loader-js loader big"></div>
</div>
`